import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["isReadingAids", "sourceProduct", "dwellTime", "loadTime"],
  _excluded2 = ["isStreamed", "loadTime"],
  _excluded3 = ["isStreamed", "loadTime"],
  _excluded4 = ["sourceIndex", "isCitation", "hostname"],
  _excluded5 = ["sourceIndex"],
  _excluded6 = ["expanded"],
  _excluded7 = ["followUpString"],
  _excluded8 = ["experimentCohort"],
  _excluded9 = ["expandButtonSource"],
  _excluded10 = ["primaryUserName"],
  _excluded11 = ["primaryUserName"],
  _excluded12 = ["resultSection", "resultTitle"],
  _excluded13 = ["resultSection", "resultTitle"],
  _excluded14 = ["additionalMatchUserName", "additionalMatchTitle"],
  _excluded15 = ["additionalMatchUserName", "additionalMatchTitle"],
  _excluded16 = ["index", "url"],
  _excluded17 = ["index", "url"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { sha256Hash } from '../utils';
import { filterCommonAttributes } from './analytics-helpers';
export var onAIAnswerDialogQueryIntent = function onAIAnswerDialogQueryIntent(props) {
  var query = props.query,
    source = props.source;
  return {
    action: 'surfaced',
    actionSubject: 'aiAnswerDialog',
    actionSubjectId: 'queryIntent',
    source: source,
    eventType: 'track',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query
    }
  };
};

// When the ai answer dialog is closed while loading before answer is shown
export var onAIAnswerDialogDroppedOff = function onAIAnswerDialogDroppedOff(props) {
  var query = props.query,
    source = props.source;
  return {
    action: 'dropoff',
    actionSubject: 'aiAnswerDialog',
    source: source,
    eventType: 'track',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query
    }
  };
};

// When the ai answer dialog exits the viewport
export var onAIAnswerDialogHidden = function onAIAnswerDialogHidden(props, dwellTime) {
  var query = props.query,
    source = props.source;
  return {
    action: 'hidden',
    actionSubject: 'aiAnswerDialog',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      dwellTime: dwellTime
    }),
    nonPrivacySafeAttributes: {
      query: query
    }
  };
};

// When the ai answer dialog is actually in the viewport
export var onAIAnswerDialogViewed = function onAIAnswerDialogViewed(props) {
  var query = props.query,
    source = props.source;
  return {
    action: 'viewed',
    actionSubject: 'aiAnswerDialog',
    source: source,
    eventType: 'track',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query
    }
  };
};

// When the ai answer loading dialog is initially shown to the user
export var onAIAnswerLoadingDialogShown = function onAIAnswerLoadingDialogShown(props, isAnimated) {
  var query = props.query,
    source = props.source;
  return {
    action: 'shown',
    actionSubject: 'aiAnswerLoadingDialog',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      isAnimated: isAnimated
    }),
    nonPrivacySafeAttributes: {
      query: query
    }
  };
};

// When query intent detection api classifies intent, routes the ui position of a smart answer
export var onSmartAnswerRouteDetection = function onSmartAnswerRouteDetection(props, smartAnswersRoute) {
  var query = props.query,
    source = props.source;
  return {
    action: 'classified',
    actionSubject: 'aiAnswerRoute',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      smartAnswersRoute: smartAnswersRoute
    }),
    nonPrivacySafeAttributes: {
      query: query
    }
  };
};
export var onAIAnswerDialogUnmount = function onAIAnswerDialogUnmount(_ref) {
  var isReadingAids = _ref.isReadingAids,
    sourceProduct = _ref.sourceProduct,
    dwellTime = _ref.dwellTime,
    loadTime = _ref.loadTime,
    props = _objectWithoutProperties(_ref, _excluded);
  var query = props.query,
    source = props.source,
    searchSessionId = props.searchSessionId;
  return {
    action: 'unmounted',
    actionSubject: 'aiAnswerDialog',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      aiFeatureName: isReadingAids ? "Definitions ".concat(sourceProduct ? "(".concat(sourceProduct, ")") : '') : 'smartAnswers',
      aiInteractionId: isReadingAids ? undefined : searchSessionId,
      aiInteractionType: isReadingAids ? undefined : 'searchSessionId',
      dwellTime: dwellTime,
      loadTime: loadTime
    }),
    nonPrivacySafeAttributes: {
      query: query
    }
  };
};

// When the ai answer result is successfully displayed to the user
export var onAIAnswerResultShown = function onAIAnswerResultShown(_ref2) {
  var isStreamed = _ref2.isStreamed,
    loadTime = _ref2.loadTime,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var query = props.query,
    answerString = props.answerString,
    source = props.source,
    cloudId = props.cloudId;
  return {
    action: 'shown',
    actionSubject: 'aiAnswerResult',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      cloudId: cloudId,
      isStreamed: isStreamed,
      loadTime: loadTime
    }),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// When there is no ai generated answer to the question
export var onAIAnswerNotShown = function onAIAnswerNotShown(_ref3) {
  var isStreamed = _ref3.isStreamed,
    loadTime = _ref3.loadTime,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var query = props.query,
    answerString = props.answerString,
    source = props.source,
    errorState = props.errorState;
  return {
    action: 'shown',
    actionSubject: 'aiAnswerError',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      isStreamed: isStreamed,
      loadTime: loadTime,
      errorState: errorState
    }),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// Tracking clicks on the expand button in SAIN answer cards
export var aiAnswerExpandClicked = function aiAnswerExpandClicked(_ref4) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref4), _ref4));
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerExpand',
    source: source,
    eventType: 'track',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// Tracking clicks on the collapse button in SAIN answer cards
export var aiAnswerCollapseClicked = function aiAnswerCollapseClicked(_ref5) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref5), _ref5));
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerCollapse',
    source: source,
    eventType: 'track',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// Tracking when the SAIN answer card is displayed in the expanded state, ie the answer is too short to collapse.
export var aiAnswerExpandShown = function aiAnswerExpandShown(_ref6) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref6), _ref6));
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'shown',
    actionSubject: 'aiAnswerExpand',
    source: source,
    eventType: 'track',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// When the user clicks the source links from the ai generated answer
export var onAIAnswerSourceClick = function onAIAnswerSourceClick(_ref7) {
  var sourceIndex = _ref7.sourceIndex,
    isCitation = _ref7.isCitation,
    hostname = _ref7.hostname,
    props = _objectWithoutProperties(_ref7, _excluded4);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerSourceLink',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      sourceIndex: sourceIndex,
      isCitation: isCitation
    }, hostname ? {
      metadata: {
        hostname: hostname
      }
    } : {}),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onAIAnswerSourceContextMenuClick = function onAIAnswerSourceContextMenuClick(_ref8) {
  var sourceIndex = _ref8.sourceIndex,
    props = _objectWithoutProperties(_ref8, _excluded5);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'contextMenuClicked',
    actionSubject: 'aiAnswerSourceLink',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      sourceIndex: sourceIndex
    }),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// When the user clicks the expand toggle button for the source section of the ai answers result
export var onAIAnswerSourceExpandToggleClick = function onAIAnswerSourceExpandToggleClick(_ref9) {
  var expanded = _ref9.expanded,
    props = _objectWithoutProperties(_ref9, _excluded6);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerSourceLink',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      expanded: expanded
    }),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// When the user clicks the return link to get back to the search results from the ai generated answer
export var onAIAnswerReturnLinkClick = function onAIAnswerReturnLinkClick(props) {
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerReturnLink',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// When the user clicks the like button for the ai generated answer
export var onLikeButtonClick = function onLikeButtonClick(props) {
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerLikeButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onDislikeButtonClick = function onDislikeButtonClick(props) {
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerDislikeButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onReportButtonClick = function onReportButtonClick(props) {
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerReportButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onFollowUpSuggestionClick = function onFollowUpSuggestionClick(_ref10) {
  var followUpString = _ref10.followUpString,
    props = _objectWithoutProperties(_ref10, _excluded7);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiFollowUpSuggestion',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      followUpHash: sha256Hash(followUpString)
    }),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString,
      followUpString: followUpString
    }
  };
};
export var onOpenChatButtonClick = function onOpenChatButtonClick(_ref11) {
  var experimentCohort = _ref11.experimentCohort,
    props = _objectWithoutProperties(_ref11, _excluded8);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerOpenChatButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      experimentCohort: experimentCohort
    }),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onExpandButtonClicked = function onExpandButtonClicked(_ref12) {
  var expandButtonSource = _ref12.expandButtonSource,
    props = _objectWithoutProperties(_ref12, _excluded9);
  var query = props.query;
  return {
    action: 'clicked',
    actionSubject: 'expandButton',
    actionSubjectId: expandButtonSource,
    source: props.source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query
    }
  };
};

// Click on primary result user profile for who question-answer
export var onWhoPrimaryViewProfileClick = function onWhoPrimaryViewProfileClick(_ref13) {
  var primaryUserName = _ref13.primaryUserName,
    props = _objectWithoutProperties(_ref13, _excluded10);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerWhoPrimaryViewProfile',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString,
      primaryUserName: primaryUserName
    }
  };
};

// Right click on primary result user profile for who question-answer
export var onWhoPrimaryViewProfileContextMenuClick = function onWhoPrimaryViewProfileContextMenuClick(_ref14) {
  var primaryUserName = _ref14.primaryUserName,
    props = _objectWithoutProperties(_ref14, _excluded11);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'contextMenuClicked',
    actionSubject: 'aiAnswerWhoPrimaryViewProfile',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString,
      primaryUserName: primaryUserName
    }
  };
};

// Click on primary result pill e.g. one of the frequent collaborators or locations for who question-answer
export var onWhoPrimaryCoordinationPillClick = function onWhoPrimaryCoordinationPillClick(_ref15) {
  var resultSection = _ref15.resultSection,
    resultTitle = _ref15.resultTitle,
    props = _objectWithoutProperties(_ref15, _excluded12);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString,
      resultTitle: resultTitle
    }
  };
};

// Right click on primary result pill e.g. one of the frequent collaborators or locations for who question-answer
export var onWhoPrimaryCoordinationPillContextMenuClick = function onWhoPrimaryCoordinationPillContextMenuClick(_ref16) {
  var resultSection = _ref16.resultSection,
    resultTitle = _ref16.resultTitle,
    props = _objectWithoutProperties(_ref16, _excluded13);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'contextMenuClicked',
    actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString,
      resultTitle: resultTitle
    }
  };
};

// Click on additional match user profile for who question-answer
export var onWhoAdditionalMatchProfileClick = function onWhoAdditionalMatchProfileClick(_ref17) {
  var additionalMatchUserName = _ref17.additionalMatchUserName,
    additionalMatchTitle = _ref17.additionalMatchTitle,
    props = _objectWithoutProperties(_ref17, _excluded14);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerWhoAdditionalMatchViewProfile',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString,
      additionalMatchUserName: additionalMatchUserName,
      additionalMatchTitle: additionalMatchTitle
    }
  };
};

// Right click on additional match user profile for who question-answer
export var onWhoAdditionalMatchProfileContextMenuClick = function onWhoAdditionalMatchProfileContextMenuClick(_ref18) {
  var additionalMatchUserName = _ref18.additionalMatchUserName,
    additionalMatchTitle = _ref18.additionalMatchTitle,
    props = _objectWithoutProperties(_ref18, _excluded15);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'contextMenuClicked',
    actionSubject: 'aiAnswerWhoAdditionalMatchViewProfile',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString,
      additionalMatchUserName: additionalMatchUserName,
      additionalMatchTitle: additionalMatchTitle
    }
  };
};
export var onRecentWorkItemClick = function onRecentWorkItemClick(_ref19) {
  var index = _ref19.index,
    url = _ref19.url,
    props = _objectWithoutProperties(_ref19, _excluded16);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerRecentWorkItem',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      url: url,
      answerString: answerString
    }
  };
};
export var onRecentWorkItemContextMenuClick = function onRecentWorkItemContextMenuClick(_ref20) {
  var index = _ref20.index,
    url = _ref20.url,
    props = _objectWithoutProperties(_ref20, _excluded17);
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'contextMenuClicked',
    actionSubject: 'aiAnswerRecentWorkItem',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      url: url,
      answerString: answerString
    }
  };
};
export var onRecentWorkLinkClick = function onRecentWorkLinkClick(props) {
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerRecentWorkListLink',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onRecentWorkLinkContextMenuClick = function onRecentWorkLinkContextMenuClick(props) {
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'contextMenuClicked',
    actionSubject: 'aiAnswerRecentWorkListLink',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// Curated Definitions
// Megan Evans from ds team requested subjects be prepended with 'ai' for data pipeline purposes

// Event when definition edit button is clicked
export var onCuratedDefinitionEditButtonClicked = function onCuratedDefinitionEditButtonClicked(props) {
  var query = props.query,
    answerString = props.answerString,
    extraAttributes = props.extraAttributes,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiCuratedDefinitionEditButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, extraAttributes),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// Event when edit definition modal next button is clicked
export var onCuratedDefinitionNextButtonClicked = function onCuratedDefinitionNextButtonClicked(props) {
  var query = props.query,
    answerString = props.answerString,
    extraAttributes = props.extraAttributes,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiCuratedDefinitionNextButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, extraAttributes),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};

// Event when edit definition modal update button is clicked
export var onCuratedDefinitionUpdateButtonClicked = function onCuratedDefinitionUpdateButtonClicked(_ref21) {
  var commonAttributes = _ref21.commonAttributes,
    newDefinition = _ref21.newDefinition,
    restrictedScope = _ref21.restrictedScope,
    sourceSelected = _ref21.sourceSelected,
    aiDefinitionEdited = _ref21.aiDefinitionEdited;
  var keyPhrase = commonAttributes.query,
    oldDefinition = commonAttributes.answerString,
    extraAttributes = commonAttributes.extraAttributes,
    source = commonAttributes.source;
  return {
    action: 'clicked',
    actionSubject: 'aiCuratedDefinitionUpdateButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, extraAttributes), {}, {
      restrictedScope: restrictedScope,
      sourceSelected: sourceSelected,
      newDefinitionLength: newDefinition.length,
      // whether the user is editing an AI answer or already edited definition
      aiDefinitionEdited: aiDefinitionEdited
    }),
    nonPrivacySafeAttributes: {
      keyPhrase: keyPhrase,
      oldDefinition: oldDefinition,
      newDefinition: newDefinition
    }
  };
};
export var onCuratedDefinitionSeeEditHistoryButtonClicked = function onCuratedDefinitionSeeEditHistoryButtonClicked(props) {
  var query = props.query,
    answerString = props.answerString,
    extraAttributes = props.extraAttributes,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, extraAttributes),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onCuratedDefinitionEditButtonShown = function onCuratedDefinitionEditButtonShown(props) {
  var query = props.query,
    answerString = props.answerString,
    extraAttributes = props.extraAttributes,
    source = props.source;
  return {
    action: 'shown',
    actionSubject: 'aiCuratedDefinitionEditButton',
    source: source,
    eventType: 'track',
    attributes: _objectSpread({}, extraAttributes),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};